var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 55,
    viewBox: "0 0 42 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12464_18603)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1205 29.1595C35.9353 26.5647 37 23.4067 37 20C37 11.1634 29.8366 4 21 4C12.1634 4 5 11.1634 5 20C5 23.4067 6.06469 26.5647 7.87947 29.1595C7.90139 29.2943 7.95236 29.4285 8.03647 29.5547L20.1679 47.7519C20.5638 48.3457 21.4362 48.3457 21.832 47.7519L33.9635 29.5547C34.0476 29.4285 34.0986 29.2943 34.1205 29.1595Z",
    fill: "#127FBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12464_18603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12464_18603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.541 27.5V22.5417L15.2493 25.0208L13.791 22.5L18.0827 20L13.791 17.5208L15.2493 15L19.541 17.4792V12.5H22.4577V17.4792L26.7494 15L28.2077 17.5208L23.916 20L28.2077 22.5L26.7494 25.0208L22.4577 22.5417V27.5H19.541Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12464_18603",
    x: 0,
    y: 0,
    width: 42,
    height: 54.1973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12464_18603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12464_18603",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.92662e19052a9910d5342736f4a5fa4f.svg";
export { ForwardRef as ReactComponent };